import * as React from "react";

export interface ScrollLoadProps {
	onLoadMore: () => void;
	targetRef: React.RefObject<HTMLDivElement>;
}

export default class ScrollLoad extends React.Component<ScrollLoadProps> {
	componentDidMount(): void {
		window.removeEventListener("scroll", this.onScroll);
		window.addEventListener("scroll", this.onScroll);
	}
	componentWillUnmount(): void {
		window.removeEventListener("scroll", this.onScroll);
	}

	onScroll = () => {
		const { onLoadMore } = this.props;
		const scrollWrapperRef = this.props.targetRef?.current as HTMLDivElement;

		const contentOffsetBottom = scrollWrapperRef.getBoundingClientRect().bottom;
		if (onLoadMore && contentOffsetBottom < window.innerHeight + 200) {
			onLoadMore();
		}
	};

	render() {
		return this.props.children;
	}
}
